module.exports = __webpack_public_path__ + "files/2c81ecebc44fe904af6bc543306efe15.png";